import { pushEvent } from '../../client/data-layer';

export const trackFilterLayoutChange = (layout: 'horizontal' | 'vertical') => {
  pushEvent('filterLayoutChange', { layout });
};
